import { Cases } from "../../../../features/Cases";
import { CasesPage } from "../../../../pages/CasesPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const casesPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.cases.root,
  element: <CasesPage />,
  name: "Кейсы",
  children: appRouterPaths.cases.item
    ? [
        {
          path: appRouterPaths.cases.item,
          element: <Cases />,
          name: "Кейс",
        },
      ]
    : undefined,
};
